import { Row } from "@tanstack/react-table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";
import { toast } from "sonner";
import { DataTable } from "@/components/ui/data-table";
import { User, userColumns } from "@/lib/columns";
import { axiosPrivate } from "@/api/axios";
import React from "react";

function Experts() {
  const [data, setData] = React.useState<User[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getData = async () => {
      try {
        const res = await axiosPrivate.get("/users/");
        if (res?.data?.success) {
          // Only keep users with role 'expert'
          setData(res.data.data.filter((user: User) => user.role === "expert"));
        }
      } catch (error) {
        // Silently handle; UI shows empty state
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  // Actions column for removing expert role
  const actions = {
    id: "actions",
    header: "Actions",
    cell: ({ row }: { row: Row<User> }) => {
      async function removeExpert() {
        try {
          const res = await axiosPrivate.put(`/users/${row.original.id}`, {
            role: "user",
          });
          toast(`Expert with ID ${row.original.id} is removed from Expert`);
          setData((prev) => {
            return prev.filter((item) => item.id !== row.original.id);
          });
        } catch (error) {
          toast.error("Something went wrong on the server side");
        }
      }
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem onClick={removeExpert}>
              Remove Expert
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  };

  const columns = React.useMemo(() => [...userColumns, actions], []);

  return (
    <div className="space-y-4">
      <h1 className="text-3xl">Expert Management</h1>
      <p>
        Manage all experts in one place. View, filter, and monitor expert users.
      </p>
      {!isLoading && (
        <DataTable
          columns={columns}
          data={data}
          placeholder="Filter Experts"
          filterColumns={["phone_number"]}
        />
      )}
    </div>
  );
}

export default Experts;
